import { jsx as e, jsxs as m } from "react/jsx-runtime";
import { Dropdown as R, KebabToggle as F, DropdownToggle as U, DropdownItem as h, PageHeader as A, Brand as C, PageHeaderTools as N, PageHeaderToolsGroup as O, PageHeaderToolsItem as p, Avatar as D } from "@patternfly/react-core";
import { useState as y, createContext as w, useContext as k, useCallback as K, useMemo as x } from "react";
import u from "@patternfly/react-styles/css/components/Avatar/avatar";
import { css as I } from "@patternfly/react-styles";
const v = ({
  isKebab: n = !1,
  title: t,
  dropDownItems: o,
  ...l
}) => {
  const [r, s] = y(!1);
  return /* @__PURE__ */ e(
    R,
    {
      ...l,
      isPlain: !0,
      position: "right",
      toggle: n ? /* @__PURE__ */ e(F, { onToggle: s, children: t }) : /* @__PURE__ */ e(U, { onToggle: s, children: t }),
      isOpen: r,
      dropdownItems: o
    }
  );
}, z = {
  avatar: "Avatar",
  fullName: "{{givenName}} {{familyName}}",
  manageAccount: "Manage account",
  signOut: "Sign out",
  unknownUser: "Anonymous"
}, T = w(z), M = () => k(T), L = ({
  translations: n,
  children: t
}) => /* @__PURE__ */ e(T.Provider, { value: n, children: t }), H = () => {
  const n = M(), t = K(
    (o, l) => {
      const r = n[o];
      return l ? Object.entries(l).reduce(
        (s, [f, i]) => s.replaceAll(`{{${f}}}`, i),
        r
      ) : r;
    },
    [n]
  );
  return x(() => ({ t }), [t]);
};
function S(n, t) {
  if (!n)
    return t("unknownUser");
  const o = n.given_name, l = n.family_name, r = n.preferred_username;
  return o && l ? t("fullName", { givenName: o, familyName: l }) : o || l || r || t("unknownUser");
}
const j = ({
  className: n = "",
  border: t,
  size: o = "md"
}) => /* @__PURE__ */ m(
  "svg",
  {
    className: I(
      u.avatar,
      u.modifiers[o],
      t === "light" && u.modifiers.light,
      t === "dark" && u.modifiers.dark,
      n
    ),
    enableBackground: "new 0 0 36 36",
    version: "1.1",
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ e(
        "circle",
        {
          style: { fillRule: "evenodd", clipRule: "evenodd", fill: "#FFFFFF" },
          cx: "18",
          cy: "18.5",
          r: "18"
        }
      ),
      /* @__PURE__ */ e("defs", { children: /* @__PURE__ */ e(
        "filter",
        {
          id: "b",
          x: "5.2",
          y: "7.2",
          width: "25.6",
          height: "53.6",
          filterUnits: "userSpaceOnUse",
          children: /* @__PURE__ */ e("feColorMatrix", { values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0" })
        }
      ) }),
      /* @__PURE__ */ e(
        "mask",
        {
          id: "a",
          x: "5.2",
          y: "7.2",
          width: "25.6",
          height: "53.6",
          maskUnits: "userSpaceOnUse",
          children: /* @__PURE__ */ e("g", { style: { filter: 'url("#b")' }, children: /* @__PURE__ */ e(
            "circle",
            {
              style: { fillRule: "evenodd", clipRule: "evenodd", fill: "#FFFFFF" },
              cx: "18",
              cy: "18.5",
              r: "18"
            }
          ) })
        }
      ),
      /* @__PURE__ */ e("g", { style: { filter: 'url("#a")' }, children: /* @__PURE__ */ m("g", { transform: "translate(5.04 6.88)", children: [
        /* @__PURE__ */ e(
          "path",
          {
            style: {
              fillRule: "evenodd",
              clipRule: "evenodd",
              fill: "#BBBBBB"
            },
            d: "m22.6 18.1c-1.1-1.4-2.3-2.2-3.5-2.6s-1.8-0.6-6.3-0.6-6.1 0.7-6.1 0.7 0 0 0 0c-1.2 0.4-2.4 1.2-3.4 2.6-2.3 2.8-3.2 12.3-3.2 14.8 0 3.2 0.4 12.3 0.6 15.4 0 0-0.4 5.5 4 5.5l-0.3-6.3-0.4-3.5 0.2-0.9c0.9 0.4 3.6 1.2 8.6 1.2 5.3 0 8-0.9 8.8-1.3l0.2 1-0.2 3.6-0.3 6.3c3 0.1 3.7-3 3.8-4.4s0.6-12.6 0.6-16.5c0.1-2.6-0.8-12.1-3.1-15z"
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            style: {
              opacity: 0.1,
              fillRule: "evenodd",
              clipRule: "evenodd"
            },
            d: "m22.5 26c-0.1-2.1-1.5-2.8-4.8-2.8l2.2 9.6s1.8-1.7 3-1.8c0 0-0.4-4.6-0.4-5z"
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            style: {
              fillRule: "evenodd",
              clipRule: "evenodd",
              fill: "#BBBBBB"
            },
            d: "m12.7 13.2c-3.5 0-6.4-2.9-6.4-6.4s2.9-6.4 6.4-6.4 6.4 2.9 6.4 6.4-2.8 6.4-6.4 6.4z"
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            style: {
              opacity: 0.08,
              fillRule: "evenodd",
              clipRule: "evenodd",
              fill: "#231F20"
            },
            d: "m9.4 6.8c0-3 2.1-5.5 4.9-6.3-0.5-0.1-1-0.2-1.6-0.2-3.5 0-6.4 2.9-6.4 6.4s2.9 6.4 6.4 6.4c0.6 0 1.1-0.1 1.6-0.2-2.8-0.6-4.9-3.1-4.9-6.1z"
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            style: {
              opacity: 0.1,
              fillRule: "evenodd",
              clipRule: "evenodd"
            },
            d: "m8.3 22.4c-2 0.4-2.9 1.4-3.1 3.5l-0.6 18.6s1.7 0.7 3.6 0.9l0.1-23z"
          }
        )
      ] }) })
    ]
  }
), B = w(void 0), _ = () => k(B), Q = ({
  keycloak: n,
  children: t
}) => {
  const [o, l] = y(n.tokenParsed), r = x(
    () => ({
      keycloak: n,
      token: o,
      updateToken: async () => {
        await n.updateToken(-1), l(n.tokenParsed);
      }
    }),
    [n, o]
  );
  return /* @__PURE__ */ e(B.Provider, { value: r, children: t });
}, V = ({
  brand: { href: n, ...t },
  avatar: o,
  features: {
    hasLogout: l = !0,
    hasManageAccount: r = !0,
    hasUsername: s = !0
  } = {},
  kebabDropdownItems: f,
  dropdownItems: i = [],
  toolbarItems: b,
  ...P
}) => {
  const { t: a } = H(), { keycloak: d } = _(), c = [];
  r && c.push(
    /* @__PURE__ */ e(
      h,
      {
        onClick: () => d?.accountManagement(),
        children: a("manageAccount")
      },
      "manageAccount"
    )
  ), l && c.push(
    /* @__PURE__ */ e(h, { onClick: () => d?.logout(), children: a("signOut") }, "signOut")
  );
  const g = d?.tokenParsed?.picture;
  return /* @__PURE__ */ e(
    A,
    {
      ...P,
      logo: /* @__PURE__ */ e(C, { ...t }),
      logoProps: { href: n },
      headerTools: /* @__PURE__ */ m(N, { children: [
        /* @__PURE__ */ m(O, { children: [
          /* @__PURE__ */ e(
            p,
            {
              visibility: {
                md: "hidden"
              },
              children: /* @__PURE__ */ e(
                v,
                {
                  "data-testid": "options-kebab",
                  isKebab: !0,
                  dropDownItems: [
                    ...f || i,
                    c
                  ]
                }
              )
            }
          ),
          /* @__PURE__ */ e(p, { children: b }),
          /* @__PURE__ */ e(
            p,
            {
              visibility: {
                default: "hidden",
                md: "visible"
              },
              children: /* @__PURE__ */ e(
                v,
                {
                  "data-testid": "options",
                  dropDownItems: [...i, c],
                  title: s ? S(d?.tokenParsed, a) : void 0
                }
              )
            }
          )
        ] }),
        g || o?.src ? /* @__PURE__ */ e(D, { src: g, alt: a("avatar"), ...o }) : /* @__PURE__ */ e(j, { ...o })
      ] })
    }
  );
};
export {
  V as KeycloakMasthead,
  Q as KeycloakProvider,
  L as TranslationsProvider,
  z as defaultTranslations,
  _ as useKeycloak
};
